<template>
    <div class="fl-check">
        <div class="container">
            <p style="margin: 20px 0">
                <b @click="showDescr = !showDescr" style="cursor: pointer; font-size: 16px; border-bottom: 2px dashed #333; font-weight: 500;">Описание</b>
                <i class="uk-icon-question-circle" style="vertical-align: top; font-size: 0.8rem; padding-left: 2px;"></i>
            </p>
            <p v-if="showDescr" style="font-size: 16px; font-weight: 400; margin: 20px 0; max-width: 960px; padding: 20px; background: #eee; border: 1px solid lightgray; border-radius: 5px;">
                <b>Среднее время проверки составляет от 0.5 до 3 минут.</b>
                <br>
                Сформированный отчёт будет загружен в виде файла в вашем браузере.
                <br>
                <br>
                Позволяет осуществить проверку даже если имеются не все необходимые исходные данные по проверяемому ФЛ. Например, когда имеются только ФИО и дата рождения или только ИНН ФЛ.
                <br>
                Позволяет найти в процессе поиска по дополнительным ресурсам, в случае наличия информации в них, расширенные установочные данные, такие как:
                <ul style="list-style-type: disc; padding-left: 25px !important;">
                    <li>выдававшиеся паспорта</li>
                    <li>ИНН ФЛ</li>
                    <li>номера телефонов, включая мобильные</li>
                    <li>связанные государственные номера автомобилей</li>
                    <li>связанные адреса.</li>
                </ul>
                Позволяет оперативно обнаружить негативные факторы в отношении ФЛ (вхождение в «черные списки», банкротство, большие суммы налоговых задолженностей или исполнительных производств и прочие), а также другую важную информацию на стадии до начала сотрудничества, а также дать основания для прекращения текущего сотрудничества, если в процессе будут выявлены новые появившиеся негативные факторы.
                <br>
                Позволяет выявить возможность сотрудничества с ФЛ в качестве ИП или самозанятого и использовать выгоды соответствующих режимов налогообложения.
                <br>
                <br>
                <b>Типовые примеры использования:</b>
                <ul style="list-style-type: disc; padding-left: 25px !important; max-width: 100%;">
                    <li>проверка потенциальных контрагентов-ФЛ</li>
                    <li>проверка кандидатов на работу</li>
                    <li>периодическая проверка отдельных контрагентов-ФЛ (например, раз в месяц/квартал/год)</li>
                    <li>периодическая проверка сотрудников (например, раз в месяц/квартал/год)</li>
                </ul>
            </p>
            <div class="fl-check__box">
                <ul class="fl-check__list">
                    <h3 class="fl-check__list__subheader">Проверяемые реестры:</h3>
                    <li :class="getClass()">Проверка паспорта</li>
                    <li :class="getClass()">Проверка ИНН</li>
                    <li :class="getClass()">Реестр федерального розыска МВД РФ</li>
                    <li :class="getClass()">Реестр террористов/экстремистов</li>
                    <li :class="getClass()">Реестр розыска ФСИН</li>
                    <li :class="getClass()">Привлечение к уголовной ответственности</li>
                    <li :class="getClass()">Реестр розыска ФССП (совершенные преступления)</li> 
                    <li :class="getClass()">Реестр розыска ФССП (по исполнительным производствам)</li>
                    <li :class="getClass()">Банк данных исполнительных производств ФССП</li>
                    <li :class="getClass()">Реестр банкротств физических лиц</li>
                    <li :class="getClass()">Реестр лиц, уволенных в связи с утратой доверия</li>
                    <li :class="getClass()">Налоговая задолженность ФЛ</li>
                    <li :class="getClass()">Реестр залогов движимого имущества</li>
                    <li :class="getClass()">Реестр дисквалифицированных лиц ФНС РОССИИ</li>
                    <li :class="getClass()">Реестр ограничений участия в ЮЛ ФНС РОССИИ</li>
                    <li :class="getClass()">Наличие статуса ИП</li>
                    <li :class="getClass()">Наличие статуса самозанятого</li>
                    <li :class="getClass()">Реестр массовых руководителей</li>
                    <li :class="getClass()">Реестр массовых учредителей</li>
                    <li :class="getClass()">Аффилированные структуры</li>
                </ul>
                <div class="form">
                    <div class="form__container">
                        <input class="form__radio" value="nameForm" v-model="formRadio" type="radio" name="formRadio">
                        <div class="form__box">
                            <div class="form__header">Фамилия<span>&#42;</span></div>
                            <input
                                class="surname"
                                :type="formRadio == 'nameForm' ? 'text' : 'password'"
                                placeholder="Фамилия"
                                v-model="surname"
                                @input="surname = surname.replace(/[^а-яa-z-]/gi, '')"
                                :class="{'paled': formRadio == 'innForm'}"
                                :disabled="formRadio == 'innForm'"
                            />
                        </div>
                        <div class="form__box">
                            <div class="form__header">Имя<span>&#42;</span></div>
                            <input
                                class="name"
                                :type="formRadio == 'nameForm' ? 'text' : 'password'"
                                placeholder="Имя"
                                v-model="name"
                                @input="name = name.replace(/[^а-яa-z-]/gi, '')"
                                :class="{'paled': formRadio == 'innForm'}"
                                :disabled="formRadio == 'innForm'"
                            />
                        </div>
                        <div class="form__box">
                            <div class="form__header">Отчество<span>&#42;</span></div>
                            <input
                                class="patronymic"
                                :type="formRadio == 'nameForm' ? 'text' : 'password'"
                                placeholder="Отчество"
                                v-model="patronymic"
                                @input="patronymic = patronymic.replace(/[^а-яa-z-]/gi, '')"
                                :class="{'paled': formRadio == 'innForm'}"
                                :disabled="formRadio == 'innForm'"
                            />
                        </div>
                        <div class="form__box">
                            <div class="form__header">Дата рождения<span>&#42;</span></div>
                            <input
                                :type="formRadio == 'nameForm' ? 'text' : 'password'"
                                v-model="birthday"
                                class="birthday"
                                placeholder="31.12.2020"
                                @input="dateFormat($event)"
                                maxlength="10"
                                :class="{'paled': formRadio == 'innForm'}"
                                :disabled="formRadio == 'innForm'"
                            />
                        </div>
                    </div>
                    <div class="form__container inn-form">
                        <input class="form__radio" v-model="formRadio" type="radio" value="innForm" name="formRadio">
                        <div class="form__box">
                            <div class="form__header">ИНН ФЛ<span>&#42;</span></div>
                            <input
                                class="inn"
                                @input="inn = inn.replace(/[^0-9]/g, '')"
                                v-model="inn"
                                placeholder="ИНН ФЛ"
                               :type="formRadio == 'innForm' ? 'text' : 'password'"
                                :maxlength="12"
                                :class="{'paled': formRadio == 'nameForm'}"
                                :disabled="formRadio == 'nameForm'"
                            />
                        </div>
                    </div>
                    <div class="form__container label-room" style=" margin: 20px 20px 0 0">
                        <label>
                            <input type="checkbox" v-model="hasApproval">
                            <span>Настоящим подтверждаю наличие письменного или иным образом зафиксированного согласия
                            физического лица на обработку его персональных данных.</span>
                        </label>
                    </div>
                    <div class="form__container" style="justify-content: flex-end; margin-top: 20px; gap: 5px;">
                        <button @click="clearForm" class="btn">Очистить</button>
                        <button @click="addData" class="btn blue" :class="{'inactive' : getInapproval()}" :disabled="getInapproval()">Поиск</button>
                    </div>
                    <p style="font-size: 14px; text-align: right;" v-if="limits">Использовано запросов: {{limits.used_total}}<span v-if="limits.total"> из {{limits.total}}</span></p>
                    <p style="text-align: end;"><span id="asterics">&#42;</span> - поля обязательные к заполнению</p>
                </div>
            </div>
        </div>
        <div v-if="status == 0 || status == 3 || loading" style="text-align: center">
            <span style="color: #444; font-size:12px">Данные подготавливаются. Приблизительное время ожидания не более 5 минут.</span>
            <shestirenka/>
        </div>
        <div v-else-if="status == 2" style="text-align: center">
            <span style="color: #444; font-size:12px">По данному запросу данных не найдено.</span>
        </div>
        <div v-else-if="status == -1 && status == -2 && status == -3" style="text-align: center">
            <span style="color: #444; font-size:12px">При запросе произошла ошибка. Повторите запрос.</span>
        </div>
        <div v-else-if="status == 4" style="text-align: center">
            <span style="color: #444; font-size:12px">Ошибка. Превышен лимит ожидания.</span>
        </div>
        <history ref="history"/>
        <flCheckPdf v-if="upload" :upload="upload" :dateCheck="dateCheck" :name="name ? name : ''" :surname="surname ? surname : ''" :patronymic="patronymic ? patronymic : ''" :birthday="birthday ? birthday : ''" :inn="inn ? inn : ''" :list="list" :formRadio="formRadio" />
    </div>
</template>

<script>
import axios from 'axios'
import shestirenka from '@/components/ui/shestirenkaLoader.vue'
import flCheckPdf from './flCheckOptimumPdf.vue'
import history from './flCheckOptimumHistory.vue'

export default {
    components: {
        shestirenka,
        flCheckPdf,
        history
    },
    data() {
        return {
            dateCheck: Date.now(),
            list: {},
            showDescr: false,
            surname: '',
            name: '',
            patronymic: '',
            inn: '',
            birthday: '',
            formRadio: 'nameForm',
            loading: false,
            hasApproval: false,
            status: 1,
            upload: false,
            requestCounter: 0,
        }
    },
    mounted() {
        if(!window.auth) {
            window.location.replace('/')
        }
    },
    methods: {
        addData() {
            this.loading = true
            this.requestCounter = 0
            axios({
                baseURL: process.env.API_FL,
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                data: {
                    method: 'id_fl',
                    data: {
                        action: "getData",
                        name: this.name && this.formRadio == "nameForm" ? this.name : '',
                        surname: this.surname && this.formRadio == "nameForm" ? this.surname : '',
                        patronymic: this.patronymic && this.formRadio == "nameForm" ? this.patronymic : '',
                        inn: this.inn && this.formRadio == "innForm" ? this.inn : '',
                        birthday: this.birthday && this.formRadio == "nameForm" ? this.birthday : ''
                    },
                    auth: {
                        sid: window.apiSession
                    }
                }
            }).then(e => {
                if(e?.data?.code == 9){
                    this.loading = false
                    UIkit.notify(
                        "Стоп-лист. Требуется подтверждение наличия согласия на обработку персональных данных.", {
                        pos: 'top-center',
                        status: 'danger',
                        timeout: 30000
                    })
                }
                else if(e?.data?.auth?.code == 9){
                    this.loading = false
                    this.$store.dispatch('showErrorPopUp', "Превышен лимит запросов")
                }
                else if(e?.data?.data?.status === 1) {
                    this.dateCheck = Date.now()
                    this.list = e.data?.data?.modules
                    this.upload = true
                    this.$refs.history.getHistory()
                }
                else if(e.data?.data?.status == 2) {
                        this.loading = false
                        this.$store.dispatch("showErrorPopUp", `По данному запросу данных не найдено`)
                        this.$refs.history.getHistory()
                } else if(e.data?.data?.status < 0 ) {
                        this.loading = false
                        this.$store.dispatch("showErrorPopUp", `Произошла ошибка, попробуйте позже или обратитесь в службу технической поддержки.`)
                        this.$refs.history.getHistory()
                } else {
                    this.loading = false
                    this.$store.dispatch("showErrorPopUp", `Произошла ошибка, попробуйте позже или обратитесь в службу технической поддержки. Ошибка: ` + e.data.message)
                    this.$refs.history.getHistory()
                }
            })
        },
        // getData(request_id) {
        //     this.upload = false
        //     this.loading = true
        //     axios({
        //         baseURL: process.env.API_FL,
        //         method: 'POST',
        //         headers: {'Content-Type': 'application/json'},
        //         data: {
        //             method: 'id_fl',
        //             data: {
        //                 action: "get",
        //                 request_id,
        //                 additional_modules: ['online_fl']
        //             },
        //             auth: {
        //                 sid: window.apiSession
        //             }
        //         }
        //     }).then(e => {
        //         if(e.data?.data?.id_fl) {
        //             this.status = e?.data?.data?.id_fl.status
        //             if(this.requestCounter === 6) {
        //                 this.loading = false
        //                 this.$store.dispatch("showErrorPopUp", `Превышено время ожидания, попробуйте позже или обратитесь в службу технической поддержки.`)
        //             }
        //             if((e.data?.data?.id_fl?.status == 0 || e.data?.data?.id_fl?.status == 3) && this.requestCounter < 6) {
        //                 setTimeout(() => {
        //                     this.getData(request_id)
        //                     this.requestCounter++
        //                 }, 10000)
        //             } else if(e.data?.data?.id_fl?.status == 2) {
        //                 this.loading = false
        //                 this.$store.dispatch("showErrorPopUp", `По данному запросу данных не найдено`)
        //                 this.$refs.history.getHistory()
        //             } else if(e.data?.data?.id_fl?.status < 0 ) {
        //                 this.loading = false
        //                 this.$store.dispatch("showErrorPopUp", `Произошла ошибка, попробуйте позже или обратитесь в службу технической поддержки.`)
        //                 this.$refs.history.getHistory()
        //             } else {
        //                 this.list = e.data?.data
        //                 this.upload = true
        //                 this.$refs.history.getHistory()
        //             }
        //         }
        //     }).catch(err => {
        //         this.$store.dispatch("showErrorPopUp", `Произошла ошибка, попробуйте позже или обратитесь в службу технической поддержки.`)
        //         console.error(err.message)
        //         this.loading = false
        //     })
        // },
        dateFormat(evt){
            let inputString = evt.target.value
            let result = true
            this.birthday = evt.target.value.replace(/[^0-9.]/g, '')
            
            if (inputString.length < this.stringCount) {
                this.stringCount = inputString.length
                result = false	
            }

            if (inputString.length === 2 && result) {
                evt.target.value += '.'
                this.stringCount = inputString.length + 1
                this.birthday = evt.target.value	
            }
            if (inputString.length === 5 && result) {
                evt.target.value += '.'
                this.stringCount = inputString.length + 1
                this.birthday = evt.target.value
            }
            result = true
        },
        clearForm() {
            this.name = '',
            this.surname = '', 
            this.patronymic = '',
            this.birthday = '',
            this.inn = ''
        },
        getInapproval() {
            if(this.formRadio == "nameForm" && (!this.hasApproval || !this.name.length || !this.surname.length || !this.patronymic.length || this.birthday.length != 10)) {
                return true
            } else if(this.formRadio == "innForm" && (!this.hasApproval || this.inn.length != 12)) {
                return true
            } else {
                return false
            }
             
        },
        getClass() {
            return {'black' : (this.formRadio == "nameForm" && this.name.length && this.surname.length && this.patronymic.length && this.birthday.length == 10) || this.formRadio == "innForm" && this.inn.length == 12}
        },
    },
    computed: {
        limits() { return this.$store.state.user?.limits?.filter(e => e.id == 110)[0] }
    }
}
</script>

<style lang="sass" scoped>
@import "styles/global-variables.sass"

.service__header
    text-align: center
    font-size: 38px
    font-weight: 700

.label-room
    display: block !important
    // margin-left: 27% !important
    label
        width: 100% !important
// .inn-form
//     margin-right: 34%
.black
    color: black !important
    font-weight: 600
    list-style-type: disc !important
.paled
    opacity: 0.4
    cursor: not-allowed
    color: white
.fl-check
    font-family: Gotham Pro, sans-serif
    // padding-top: 5%
    &__header-folder
        display: flex
        justify-content: center
    ul
        padding: 0
        width: 100%
        max-width: 450px
            
    &__header
        @extend .service__header
        margin-left: 5px
    &__box
        display: flex
    &__list
        &__subheader
            font-size: 24px
            font-weight: 600
            margin-bottom: 20px
        li
            color: rgb(157, 173, 196)
            font-size: 14px
            list-style-type: circle
.form
    display: flex
    flex-direction: column
    &__limits
        text-align: end
        font-size: 14px
    .form__container:first-child .form__box
        margin-top: 0
    &__box
        margin: 15px 10px 0 0
        .name
            margin: 0
        .birthday
            width: 116px
        .inn
            width: 370px
        .serial
            width: 130px
        input
            min-height: 30px
            border-radius: 3px
            padding: 4px 8px
            border: 1px solid #b8b8b8
            box-shadow: none
            text-align: left
            width: 187px
    &__radio
        margin: 38px 10px 0 0
    &__header
        margin: 2px auto
        font-weight: 400
        font-size: 14px
    &__container
        display: flex !important 
        margin-left: 8% !important
        // justify-content: flex-end
        label
            vertical-align: top
            font-size: 14px
            width: 65%
            input[type="checkbox"],
            span
                vertical-align: top
            span
                display: inline-block
                width: 95%
        &_lower
            margin-top: 20px
.btn
    display: inline-block
    vertical-align: top
    font-family: Gotham Pro, sans-serif
    width: 110px
    height: 34px
    text-align: center
    line-height: 34px
    font-weight: 400
    font-size: 14px
    border: 0
    border-radius: 5px
    cursor: pointer
    color: #333
    background-color: transparent
    &:active
        color: #484747
        background-color: #a7baf9
.blue
    color: #fff
    background-color: #4771f3
    margin-right: 10px
    
.inactive
    opacity: 0.5
    cursor: not-allowed

@media (max-width: 1440px)
    .inn-form
        margin-right: 41%
    .label-room
        display: block
        // margin-left: 13% !important 
        label
            width: 100%
@media (max-width: 1280px)
    .inn-form
        margin-right: 40%
    .form
        display: flex
        flex-direction: column
        &__box
            margin: 15px 10px 0 0
            .name
                margin: 0
            .birthday
                width: 110px
            .inn
                width: 308px
            .serial
                width: 80px
            input
                width: 130px
    .label-room
        display: block
        margin-left: 3% !important
        label
            width: 100%

</style>